import AccountingMonitorPage from "./accountingMonitorPage";
export default AccountingMonitorPage;
